module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item !== null) ? _c('div', [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('item-form', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "saved": _vm.reloadItem
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Products containing this item")]), _vm._v(" "), _vm._l((_vm.linkedProducts), function(product) {
    return _c('div', [_c('router-link', {
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: product.id
          }
        }
      }
    }, [_vm._v("\n                    " + _vm._s(product.name) + "\n                ")])], 1)
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', [_vm._v("Add this item to a product...")])], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-041f31c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/items/ItemEdit.vue
// module id = 492
// module chunks = 0